/**
 * @generated SignedSource<<3dc39109bfe59e0f1e6c3ec6d08c51c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignSystemRoleInput = {
  adminId: string;
  applicationId?: string | null | undefined;
  roleId?: string | null | undefined;
  roleName?: string | null | undefined;
  systemId: string;
};
export type useAdminMutationsAssignSystemRoleMutation$variables = {
  input: AssignSystemRoleInput;
};
export type useAdminMutationsAssignSystemRoleMutation$data = {
  readonly assignSystemRole: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
      readonly vars: any | null | undefined;
    }>;
    readonly result: {
      readonly adminId: string;
      readonly id: string;
      readonly role: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly roleId: string;
      readonly systemId: string;
    } | null | undefined;
  };
};
export type useAdminMutationsAssignSystemRoleMutation = {
  response: useAdminMutationsAssignSystemRoleMutation$data;
  variables: useAdminMutationsAssignSystemRoleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AssignSystemRoleResult",
    "kind": "LinkedField",
    "name": "assignSystemRole",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminSystemRole",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adminId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "systemId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roleId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vars",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAdminMutationsAssignSystemRoleMutation",
    "selections": (v2/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAdminMutationsAssignSystemRoleMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "965eadeeb730af449d4abeaa39d15a71",
    "id": null,
    "metadata": {},
    "name": "useAdminMutationsAssignSystemRoleMutation",
    "operationKind": "mutation",
    "text": "mutation useAdminMutationsAssignSystemRoleMutation(\n  $input: AssignSystemRoleInput!\n) {\n  assignSystemRole(input: $input) {\n    result {\n      id\n      adminId\n      systemId\n      roleId\n      role {\n        id\n        name\n      }\n    }\n    errors {\n      message\n      fields\n      code\n      shortMessage\n      vars\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c5b58d929db278fd6b891b452c656d8f";

export default node;
